import React from "react";
import "./MyOrder.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from '@fortawesome/free-solid-svg-icons';

const MyOrder = () => {
  return (
    <div>
      <table className="Wishlist_table table table-borderless text-white">

        <thead>
          <tr >
            <th class="product-thumbnail  p-0 w25">
              <div class="cl-pm">
                Product
              </div>
            </th>
            <th class="product-name  p-0">
              <div class="cl-pm d-flex  justify-content-center">

              </div>
            </th>
            <th class="product-name  p-0">
              <div class="cl-pm">
                Date
              </div>
            </th>

            <th class="product-price p-0">
              <div class="cl-pm d-flex  justify-content-center">
                Qty
              </div>
            </th>

            <th class="product-stock-status  p-0">
              <div class="cl-pm d-flex  justify-content-center">
                Price
              </div>
            </th>

            <th class="product-add-to-cart  p-0">
              <div class="cl-pm d-flex  justify-content-center">
                Action
              </div>
            </th>

          </tr>
        </thead>

        <tbody>

          <tr className='btm_border_dash'>

            <td className="product-thumbnail w25">
              <div className="cart-img">
                <img src={require("../../../Asset/cart/Group 281.png")} />
              </div>
            </td>

            <td className="product-name ">
              Abstract Oil Painting
              <br />
              By <span className="cl-pm">Kaven Morgan</span>,
              <span> Size: 15”x10”</span>
              <pre></pre>

            </td>
            <td className="product-date">
              20 Feb 2022
            </td>
            <td className="product-quantity ">
              <div class="d-flex  justify-content-center">
                1
              </div>
            </td>
            <td className="product-price">
              <div class="d-flex  justify-content-center">
                $150.00
              </div>
            </td>
            <td className="product-action ">
              <div class="d-flex  justify-content-center cursor">
                <FontAwesomeIcon className="cl-pm" icon={faEye} />
              </div>
            </td>
          </tr>


          <tr className='btm_border_dash'>
            <td className="product-thumbnail ">
              <div className="cart-img">
                <img src={require("../../../Asset/cart/Group 281.png")} />
              </div>
            </td>
            <td className="product-name">
              Abstract Oil Painting
              <br />
              By <span className="cl-pm">Kaven Morgan</span>,
              <span> Size: 15”x10”</span>
            </td>
            <td className="product-date">
              20 Feb 2022
            </td>
            <td className="product-quantity ">
              <div class="d-flex  justify-content-center">
                1
              </div>
            </td>
            <td className="product-price">
              <div class="d-flex  justify-content-center">
                $150.00
              </div>
            </td>
            <td className="product-action ">
              <div class="d-flex  justify-content-center cursor">
                <FontAwesomeIcon className="cl-pm" icon={faEye} />
              </div>
            </td>
          </tr>

        </tbody>

      </table>
    </div>
  );
};

export default MyOrder;
